<template>
  <div class="content-block">
    <StatesEditor></StatesEditor>
    <GraphsTable></GraphsTable>
    <GroupNotifications></GroupNotifications>
  </div>
</template>

<script>
import StatesEditor from './states-editor'
import GraphsTable from './graphs-table'
import GroupNotifications from './group-notifications'

export default {
    name: 'EntityStatesSettings',
    components: {
        StatesEditor,
        GraphsTable,
        GroupNotifications,
    },
    props: {
    },
    data() {
        return {}
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    },
}
</script>

<style scoped>

</style>

